function hide(element) {
  element.classList.add("visually_hidden");
  setTimeout(() => {
    element.classList.add("display_hidden");
  }, 100);
}

function show(element) {
  element.classList.remove("display_hidden");
  setTimeout(() => {
    element.classList.remove("visually_hidden");
  }, 100);
}

/**
 * filter the Results
 * @param {string} filterQuery
 * @param {NodeList} filterNodes
 */
export const filterNodesUpdate = (filterQuery, filterNodes) => {
  filterNodes.forEach((node) => {
    const categoriesOfThisNode = JSON.parse(node.dataset.categories);
    /* hide all first */
    hide(node);
    /* show only matching ones after hide setTimeout */
    if (categoriesOfThisNode.includes(filterQuery)) {
      setTimeout(() => {
        show(node);
      }, 100);
    }
  });
};

/**
 * toggle .active state on the Filter links
 * @param {string} filterQuery
 * @param {NodeList} filterInput
 */
export const filterInputUpdate = (filterQuery, filterInput) => {
  filterInput.forEach((node) => {
    if (filterQuery === node.dataset?.filter) {
      node.classList.add("active");
    } else {
      node.classList.remove("active");
    }
  });
  console.log("filterInputUpdate", filterQuery);
  
};

console.log("filter.js loaded");
